// import demoData from "../assets/sampleData/sample1";
import demoData from "../assets/sampleData/data";

// Use demo videos
import vid from "../assets/sampleVideos/Raw.mp4";
import thumbnail1 from "../assets/sampleVideos/Raw.jpg";

import vid2 from "../assets/sampleVideos/GFlow.mp4";
import thumbnail2 from "../assets/sampleVideos/GFlow.jpg";

import thumbnail3 from "../assets/sampleVideos/GFlowOverlay.jpg";
import vid3 from "../assets/sampleVideos/GFlowOverlay.mp4";

import thumbnail4 from "../assets/sampleVideos/SteeringFpIImageOnlyViz00.jpg";
import vid4 from "../assets/sampleVideos/SteeringFpIImageOnlyViz00.mp4";

import thumbnail5 from "../assets/sampleVideos/SteeringFpIImageOnlyViz20.jpg";
import vid5 from "../assets/sampleVideos/SteeringFpIImageOnlyViz20.mp4";

import thumbnail6 from "../assets/sampleVideos/SteeringFpIImageOnlyViz90.jpg";
import vid6 from "../assets/sampleVideos/SteeringFpIImageOnlyViz90.mp4";

import thumbnail7 from "../assets/sampleVideos/SteeringFpIImageOnlyViz95.jpg";
import vid7 from "../assets/sampleVideos/SteeringFpIImageOnlyViz95.mp4";

import thumbnail8 from "../assets/sampleVideos/SteeringFpIVizFlowOnly00.jpg";
import vid8 from "../assets/sampleVideos/SteeringFpIVizFlowOnly00.mp4";

import thumbnail9 from "../assets/sampleVideos/SteeringFpIVizFlowOnly20.jpg";
import vid9 from "../assets/sampleVideos/SteeringFpIVizFlowOnly20.mp4";

import thumbnail10 from "../assets/sampleVideos/SteeringFpIVizFlowOnly90.jpg";
import vid10 from "../assets/sampleVideos/SteeringFpIVizFlowOnly90.mp4";

import thumbnail11 from "../assets/sampleVideos/SteeringFpIVizFlowOnly95.jpg";
import vid11 from "../assets/sampleVideos/SteeringFpIVizFlowOnly95.mp4";

demoData.metadata.videos[0].url = vid;
demoData.metadata.videos[0].thumbnail = thumbnail1;
demoData.metadata.videos[1].url = vid2;
demoData.metadata.videos[1].thumbnail = thumbnail2;
demoData.metadata.videos[2].url = vid3;
demoData.metadata.videos[2].thumbnail = thumbnail3;
demoData.metadata.videos[3].url = vid4;
demoData.metadata.videos[3].thumbnail = thumbnail4;
demoData.metadata.videos[4].url = vid5;
demoData.metadata.videos[4].thumbnail = thumbnail5;
demoData.metadata.videos[5].url = vid6;
demoData.metadata.videos[5].thumbnail = thumbnail6;
demoData.metadata.videos[6].url = vid7;
demoData.metadata.videos[6].thumbnail = thumbnail7;
demoData.metadata.videos[7].url = vid8;
demoData.metadata.videos[7].thumbnail = thumbnail8;

demoData.metadata.videos[8].url = vid9;
demoData.metadata.videos[8].thumbnail = thumbnail9;
demoData.metadata.videos[9].url = vid10;
demoData.metadata.videos[9].thumbnail = thumbnail10;
demoData.metadata.videos[10].url = vid11;
demoData.metadata.videos[10].thumbnail = thumbnail11;


demoData.data.forEach(a => {
  a.speed = Math.round(a.speed);
  a.acceleration.units = a.acceleration.units.replace('^2', '²');
  a.steering.units = a.steering.units.replace('^2', '²');
});

export default demoData;
